import React, { $api, $tools, antdUI, useEffect, useState } from 'react';
import './index.scss';
import { Link } from "react-router-dom";
import OrderDetail from './orderDetail'
import ItemDetailPopover from '@/components/itemDetailPopover'
import SaleItemContainer from '../saleItemContainer'
import { useI18n } from '@/i18n';

const getSendAllTradeofferTips = t => (
    <div className="apikey-box-text" style={ {
        padding: '14px', width: '380px', backgroundColor: '#191919',
        boxShadow: `0px 0px 6px 1px #191919`
    } }>
        <p className="title"
           style={ { fontSize: '14px', color: '#8c9298', marginBottom: '8px' } }>{ t('一键发送报价注意事项：') }</p>
        <p style={ {
            color: '#fff',
            fontSize: '14px'
        } }>{ t('1.发送过程约2分钟，请耐心等待；') }</p>
        <p style={ {
            color: '#fff',
            fontSize: '14px'
        } }>{ t('2.需要用户自行刷新页面查看订单变化；') }</p>
        <p style={ { color: '#fff', fontSize: '14px' } }>{ t('3.如果发现订单未发送报价的情况，请参考以下情况：') }</p>
        <p style={ { color: '#999', fontSize: '14px' } }>{ t('3-1.检查与对方的交易报价是否过多') }</p>
        <p style={ { color: '#999', fontSize: '14px' } }>{ t('3-2.Steam游戏物品服务器可能处于停机状态，或者 Steam 可能暂时遇到连接问题。请稍后再试。') }</p>
        <p style={ { color: '#999', fontSize: '14px' } }>{ t('3-3.当前卖家是否已经绑定了 Steam 手机令牌并大于 15 天 ！') }</p>
    </div>
)
const getPageType = (quality) => {
    if (quality === "strange" || quality === "unusual_strange") {
        return 2
    } else {
        return 1
    }
}

const steamId64Base = '76561197960265728';
const addDecimalStrings = (left, right) => {
    let carry = 0, result = '', i = left.length - 1, j = right.length - 1;
    while (i >= 0 || j >= 0 || carry) {
        const sum = Number(left[i] || 0) + Number(right[j] || 0) + carry;
        result = String(sum % 10) + result;
        carry = Math.floor(sum / 10);
        i--;
        j--;
    }
    return result;
}
const getSteamProfileUrl = transactionLink => {
    if (! transactionLink) return '';
    try {
        const partner = new URL(transactionLink).searchParams.get('partner');
        if (! partner || ! /^\d+$/.test(partner)) return '';
        const steamid = addDecimalStrings(steamId64Base, partner);
        return `https://steamcommunity.com/profiles/${ steamid }`;
    } catch (e) {
        return '';
    }
}

function OrderContainer(props) {
    const { t, itemName, language } = useI18n();
    const { saleData, getData, currentNav, onSaleCurNav, onShelfData, set_onShelfData, currentGame } = props;
    const [ orderDetailView, setOrderDetailView ] = useState(false);
    const [ allPrice, setAllPrice ] = useState(0);
    const [ orderDetailData, setOrderDetailData ] = useState([]);
    const [ countDownList, setCountDownList ] = useState({});
    const {
        checkResult, debounce, BASE_STEAM_IMG,
        orderStatusMessage, countDown, calculationTargetTime, obj2strUrl, cancelOrderTime
    } = $tools
    const [ sendBtnLoading, setSendBtnLoading ] = useState(false)
    
    const [ loadingList, setLoadingList ] = useState(Array.from({ length: saleData.length }));
    const [ disabledList, setDisabledList ] = useState(Array.from({ length: saleData.length }, () => true));
    const handleCancelEvent = (t) => setDisabledList([ ...t.map(_ => ! _ || new Date(
        new Date().toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })
    ).getTime() <= _) ])
    
    function handleLoading(index, val) {
        let list = [ ...loadingList ]
        list[index] = val
        setLoadingList(list)
    }
    
    const cancelOrder = async ({ orderNumber, appid, index, orderItemsStatus }) => {
        handleLoading(index, true)
        let result = await $api.order.saleOrderCancel({ orderNumber, appid, orderItemsStatus })
        handleLoading(index, false)
        if (checkResult(result)) {
            antdUI.message.success(t('取消中...'))
            getData();
        }
    }
    const orderCountDown = (targData, timer) => {
        const time = targData.map((_, index) => [ index, calculationTargetTime(_) ]);
        const ctime = targData.map(_ => cancelOrderTime(_));
        let list = {}
        time.forEach(_ => list[_[0]] = countDown({ time: _[1], type: 'order' }))
        setCountDownList({ ...list })
        timer = setInterval(() => {
            time.forEach(_ => {
                if (_[1] === " ") {
                    list[_[0]] = ""
                } else if (_[1] === "暂无时间信息") {
                    list[_[0]] = t('暂无时间信息')
                } else {
                    list[_[0]] = countDown({ time: _[1], type: 'order' })
                }
            })
            handleCancelEvent(ctime)
            setCountDownList({ ...list })  // 得浅克隆区分地址
        }, 1000)
    }
    
    useEffect(() => {
        let timer
        orderCountDown(saleData, timer)
        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    const checkSaleOrderTime = orderItem => {
        const { offSendTime, duetime, orderItemsStatus, suspendedTime, orderType } = orderItem
        const tHTime = _ => _ * 60 * 60 * 1000;
        const curTime = new Date().getTime()
        const _duetime = new Date(duetime?.replace(/-/g, '/')).getTime()
        const _offSendTime = new Date(offSendTime?.replace(/-/g, '/')).getTime()
        const _suspendedTime = new Date(suspendedTime).getTime()
        switch (orderItemsStatus) {
            case 4:
                return curTime > (_duetime + tHTime(orderType === 'sale' ? 12 : 0.5) + 35 * 60 * 1000);
            case 6:
                return curTime > (_duetime + tHTime(orderType === 'sale' ? 12 : 0.5) + 5 * 60 * 1000);
            case 7:
                return curTime > (_offSendTime + tHTime(12) + 5 * 60 * 1000);
            case 8:
                return curTime > (_offSendTime + tHTime(24) + 5 * 60 * 1000);
            case 10:
                return curTime > (_offSendTime + tHTime(12) + 5 * 60 * 1000);
            case 11:
                if (! suspendedTime) return false
                return curTime > _suspendedTime
            default:
                return false
        }
    }
    
    const manualCheckSaleOrderBtnOnChange = async ({ appid, orderNumber }) => {
        const result = await $api.tradeoffer.manualCheckSaleOrder({ appid, orderNumber })
        if (checkResult(result)) {
            if (result?.data?.message) {
                antdUI.message.success(result?.data?.message)
            } else {
                antdUI.message.success(t('订单效验成功！'))
            }
            getData();
        }
    }
    
    const sendSteamOffer = async ({ appid, orderNumber }) => {
        setSendBtnLoading(true)
        const result = await $api.tradeoffer.sendSteamOffer({ appid, orderNumber })
        setSendBtnLoading(false)
        if (checkResult(result)) {
            if (result?.data?.message) {
                antdUI.message.success(result?.data?.message)
            } else {
                antdUI.message.success(t('报价发送成功！'))
            }
            getData();
        }
    }
    const sendAllSteamOffer = async () => {
        setSendBtnLoading(true)
        const result = await $api.tradeoffer.sendAllSteamOffer()
        setSendBtnLoading(false)
        if (checkResult(result)) {
            antdUI.message.success(t('报价正在发送中！约2分钟左右完成'))
        }
    }
    
    let dataSource = [], columns;
    if (saleData[0] !== 'no') {
        switch (currentNav) {
            case 'onSale':
                columns = getOnSaleColumns(t);
                saleData.forEach((item, index) => {
                    const buyerSteamProfileUrl = getSteamProfileUrl(
                        item.transactionLink || item.buyerSteamInfo?.transactionLink
                    );
                    item.market_item_detail = {
                        error: 0,
                        msg: {
                            floatvalue: item.floatvalue,
                            stickers: item.stickers || [],
                            paintseed: item.paintseed,
                            paintindex: item.paintindex,
                            customname: item.customname
                        }
                    }
                    dataSource.push({
                        key: index,
                        orderNumber: (
                            <div style={ orderNumber }
                                 className="order-numbers">{ item.orderNumber }{ item.offerCode ? `-(${ item.offerCode })` : "" }</div>
                        ),
                        itemInfo: (
                            <Link
                                to={
                                    {
                                        pathname: '/marketPlace/accessoriesList',
                                        search: obj2strUrl({
                                            id: item.itemid,
                                            curGame: item.appid,
                                            curType: getPageType(item?.CsgoItem?.quality),
                                        }, '?')
                                    }
                                }
                                target='_blank'
                            >
                                <div className="orderTable item-info-box">
                                    <antdUI.Popover placement="rightTop"
                                                    content={ <ItemDetailPopover type="onSale" csData={ item }/> }>
                                        <div style={ favoritesItemStyle } className="favorites-item">
                                            <img style={ tabImg }
                                                 src={ BASE_STEAM_IMG + item.icon_url } alt=""
                                            />
                                        </div>
                                    </antdUI.Popover>
                                    {
                                        Number(currentGame) === 730 ? <div className="on-shelf-item-name">
                                            <p className="item-name one-text-flow">{ itemName(item) }</p>
                                            { item.floatvalue !== '0' &&
                                                <p className="floatval text-ov1">{ item.floatvalue && `${ t('磨损') }:${ item.floatvalue }` }</p> }
                                        </div> : <div className="on-shelf-item-name">
                                            <p className="item-name one-text-flow"
                                               style={ { margin: '10px 0' } }>{ itemName(item) }</p>
                                        </div>
                                    }
                                </div>
                            </Link>
                        ),
                        sellingPrice: (
                            <div style={ { ...tabBox, fontSize: '16px', color: '#2DAF61' } }
                                 className="on-shelf-item-name">
                                ￥{ item.sellingPrice }
                            </div>
                        ),
                        buyerSteamInfo: <div style={ { ...tabBox, display: "block" } }>
                            <div className="flex jtyct ait">
                                <antdUI.Avatar style={ { marginRight: '10px' } }
                                               src={ item.buyerSteamInfo?.avatar }></antdUI.Avatar>
                                <p>[<span
                                    style={ { color: '#2DAF61' } }>{ item.buyerSteamInfo?.steamName || t('未知') }</span>]
                                </p>
                            </div>
                            { item.buyerSteamInfo?.qq && <p style={ {
                                textAlign: 'center',
                                fontSize: '12px'
                            } }>QQ：{ item.buyerSteamInfo.qq }</p> }
                            <p style={ {
                                textAlign: 'center',
                                fontSize: '12px'
                            } }>{ t('注册时间') }<br/> { item.buyerSteamInfo?.steamRegistrationTime || t('未知') }
                            </p>
                            { buyerSteamProfileUrl && <a
                                href={ buyerSteamProfileUrl }
                                target="_blank"
                                rel="noopener noreferrer"
                                style={ {
                                    display: 'block',
                                    marginTop: '6px',
                                    textAlign: 'center',
                                    color: '#2DAF61'
                                } }
                            >{ t('查看买家Steam主页') }</a> }
                        </div>,
                        duetime: <div style={ tabBox }><p
                            style={ { textAlign: "center" } }>{ item.duetime ? item.duetime : t('暂无') }</p></div>,
                        orderItemsStatus: <>
                            <div style={ { ...tabBox, width: '180px', margin: '0 auto' } }
                                 dangerouslySetInnerHTML={ {
                                     __html: orderStatusMessage({
                                         type: 'sale', cancelStatus: item.cancelStatus,
                                         status: item.orderItemsStatus, orderMsg: item.orderMessage,
                                         deliveryMethod: item.deliveryMethod,
                                         language
                                     })
                                 } }
                            />
                            <div className="count-down">{
                                countDownList[index]
                            }</div>
                            <antdUI.Button type="primary"
                                           style={ { display: 'block', margin: '4px auto' } }
                                           disabled={ disabledList[index] || item.cancelStatus === 1 || item.cancelStatus === 2 || item.tradeofferid || item.orderType === 'buying' }
                                           loading={ loadingList[index] }
                                           onClick={ () => cancelOrder({
                                               orderNumber: item.orderNumber, appid: item.appid, index,
                                               orderItemsStatus: item.orderItemsStatus,
                                           }) }>{ t('取消订单') }
                            </antdUI.Button>
                            { checkSaleOrderTime(item) &&
                                <antdUI.Button type="primary"
                                               style={ { display: 'block', margin: '4px auto' } }
                                               onClick={ () => manualCheckSaleOrderBtnOnChange(item) }>{ t('卖家报价验证') }
                                </antdUI.Button> }
                            { item.orderItemsStatus === 6 && item.deliveryMethod === "sb" // deliveryMethod => seller
                                && <antdUI.Button type="primary" loading={ sendBtnLoading }
                                                  style={ { display: 'block', margin: '4px auto' } }
                                                  onClick={ () => sendSteamOffer(item) }>{ t('发送报价') }
                                </antdUI.Button> }
                        </>
                    })
                })
                break;
            case 'intermediary':
                columns = getIntColumns(t);
                saleData.forEach((item, index) => {
                    dataSource.push({
                        key: index,
                        orderNumber: (
                            <div style={ orderNumber } className="order-numbers">{ item.orderNumber }</div>
                        ),
                        itemTotal: (
                            <div style={ tabBox } className="on-shelf-item-name">
                                { t('共') }{ item.itemTotal }{ t('件') }
                            </div>
                        ),
                        price: <div style={ { ...tabBox, color: '#2eb062' } }>￥<h1
                            style={ { ...tabH, color: '#2eb062' } }>{ item.totalPrice }</h1></div>,
                        buyer: <div style={ tabBox }>{ item.buyerid ? item?.User?.nickname : t('暂无') }</div>,
                        handlingFee: <div style={ { ...tabBox, color: '#2eb062' } }>￥<h2
                            style={ { ...tabH, color: '#2eb062' } }>{ item.handlingFee }</h2></div>,
                        createTime: <div style={ tabBox }>{ item.create_time }</div>,
                        orderStatus: <div style={ { ...tabBox } }
                                          dangerouslySetInnerHTML={ {
                                              __html: orderStatusMessage({
                                                  type: 'int',
                                                  status: item.orderStatus,
                                                  language,
                                              })
                                          } }
                        />,
                        // orderLink: <div style={tabBox}>{`${window.location.host}/myRequest?orderLink=${item.orderNumber}`}</div>,
                        operating: <div style={ { ...tabBox, } }>
                            <antdUI.Button type="primary" style={ { marginRight: '4px' } } onClick={ () => {
                                setAllPrice(item.totalPrice)
                                setOrderDetailData(item.IntermediaryListings)
                                setOrderDetailView(true)
                            } }>{ t('查看详情') }
                            </antdUI.Button>
                            { item.orderStatus === '1' || item.orderStatus === '2' ? <antdUI.Button
                                    onClick={ debounce(cancelOrder, 1000, true).bind(null, item.orderNumber) }>{ t('取消订单') }</antdUI.Button>
                                : <antdUI.Button disabled>{ t('取消订单') }</antdUI.Button>
                            }
                        </div>
                    })
                })
                break;
            case 'record':
                columns = getOnSaleColumns(t).map(item => {
                    if (item.key === "buyerSteamInfo") return {
                        title: <p style={ titleStyle }>{ t('订单完成时间') }</p>,
                        dataIndex: 'endtime',
                        key: 'endtime',
                        render: text => text
                    }
                    return item
                });
                saleData.forEach((item, index) => {
                    item.market_item_detail = {
                        error: 0,
                        msg: {
                            floatvalue: item.floatvalue,
                            stickers: item.stickers || [],
                            paintseed: item.paintseed,
                            paintindex: item.paintindex,
                            customname: item.customname
                        }
                    }
                    dataSource.push({
                        key: index,
                        orderNumber: (
                            <div style={ orderNumber }
                                 className="order-numbers">{ item.orderNumber }{ item.offerCode ? `-(${ item.offerCode })` : "" }</div>
                        ),
                        itemInfo: (
                            <Link
                                to={
                                    {
                                        pathname: '/marketPlace/accessoriesList',
                                        search: obj2strUrl({
                                            id: item.itemid,
                                            curGame: item.appid,
                                            curType: getPageType(item?.CsgoItem?.quality)
                                        }, '?')
                                    }
                                }
                                target='_blank'
                            >
                                <div className="orderTable item-info-box">
                                    <antdUI.Popover placement="rightTop"
                                                    content={ <ItemDetailPopover type="onSale" csData={ item }/> }>
                                        <div style={ favoritesItemStyle } className="favorites-item">
                                            <img style={ tabImg }
                                                 src={ BASE_STEAM_IMG + item.icon_url } alt=""
                                            />
                                        </div>
                                    </antdUI.Popover>
                                    <div className="on-shelf-item-name">
                                        <p className="item-name one-text-flow">{ itemName(item) }</p>
                                        { item.floatvalue !== '0' &&
                                            <p className="floatval text-ov1">{ item.floatvalue && `${ t('磨损') }:${ item.floatvalue }` }</p> }
                                    </div>
                                </div>
                            </Link>
                        ),
                        sellingPrice: (
                            <div style={ { ...tabBox, fontSize: '16px', color: '#2DAF61' } }
                                 className="on-shelf-item-name">
                                ￥{ item.sellingPrice }
                            </div>
                        ),
                        duetime: <div style={ tabBox }><p
                            style={ { textAlign: "center" } }>{ item.duetime ? item.duetime : t('暂无') }</p></div>,
                        endtime: <div style={ tabBox }><p
                            style={ { textAlign: "center" } }>{ item.endtime ? item.endtime : t('暂无') }</p></div>,
                        orderItemsStatus: <div style={ { ...tabBox } }
                                               dangerouslySetInnerHTML={ {
                                                   __html: orderStatusMessage({
                                                       type: 'sale',
                                                       main: 'seller',
                                                       orderMsg: item.orderMessage,
                                                       status: item.orderItemsStatus,
                                                       language
                                                   })
                                               } }
                        />
                    })
                })
                break;
            default:
                break;
        }
    }
    
    return (
        <div className="order-container">
            { currentNav === 'onSale' ?
                onSaleCurNav === 'sale' ?
                    (saleData[0] ? <SaleItemContainer currentGame={ currentGame }
                                                      saleData={ saleData } set_onShelfData={ set_onShelfData }
                                                      onShelfData={ onShelfData }></SaleItemContainer>
                        : <antdUI.Empty></antdUI.Empty>)
                    : onSaleCurNav === 'ship' ?
                        <>
                            <div className="flex ait" style={ {
                                margin: '4px auto',
                                position: "absolute",
                                top: '-65px',
                                gap: "10px",
                                right: '0%',
                            } }>
                                <antdUI.Popover
                                    placement="left"
                                    content={ getSendAllTradeofferTips(t) }
                                >
                                    <i className="iconfont icon-wenhao"></i>
                                </antdUI.Popover>
                                <antdUI.Button type="primary" loading={ sendBtnLoading }
                                               onClick={ () => sendAllSteamOffer() }>{ t('一键发送报价') }
                                </antdUI.Button>
                            </div>
                            
                            <antdUI.Table
                                pagination={ false }
                                dataSource={ dataSource }
                                // locale={{ emptyText: '暂无数据' }}
                                columns={ columns }
                            >
                            </antdUI.Table>
                        </>
                        : ''
                : <antdUI.Table
                    pagination={ false }
                    dataSource={ dataSource }
                    // locale={{ emptyText: '暂无数据' }}
                    columns={ columns }
                >
                </antdUI.Table>
            }
            
            { orderDetailView && <OrderDetail orderDetailView={ orderDetailView }
                                              setOrderDetailView={ setOrderDetailView }
                                              orderDetailData={ orderDetailData } allPrice={ allPrice }/> }
        </div>
    )
}

let tabBox = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        color: '#000'
    },
    tabH = {
        fontSize: '18px',
        fontWeight: 600,
        color: 'rgb(240, 147, 41)',
    },
    orderNumber = {
        color: '#000',
        textAlign: 'center'
    },
    favoritesItemStyle = {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundSize: 'cover',
        transform: 'scale(1.3)',
        backgroundImage: `url(${ require('@/images/items/item_bg.png') })`
    },
    tabImg = {
        width: '65px'
    };
let titleStyle = { textAlign: 'center', fontWeight: 900, fontSize: '14px' };
const getOnSaleColumns = t => [
    {
        title: <p style={ titleStyle }>{ t('订单号(验证码)') }</p>,
        dataIndex: 'orderNumber',
        key: 'orderNumber',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('饰品名称') }</p>,
        dataIndex: 'itemInfo',
        key: 'itemInfo',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('订单金额') }</p>,
        dataIndex: 'sellingPrice',
        key: 'sellingPrice',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('购买时间') }</p>,
        dataIndex: 'duetime',
        key: 'duetime',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('买家信息') }</p>,
        dataIndex: 'buyerSteamInfo',
        key: 'buyerSteamInfo',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('交易状态') }</p>,
        dataIndex: 'orderItemsStatus',
        key: 'orderItemsStatus',
        render: text => text
    }
];
const getIntColumns = t => [
    {
        title: <p style={ titleStyle }>{ t('订单号') }</p>,
        dataIndex: 'orderNumber',
        key: 'orderNumber',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('数量') }</p>,
        dataIndex: 'itemTotal',
        key: 'itemTotal',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('交易价格') }</p>,
        dataIndex: 'price',
        key: 'price',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('买家昵称') }</p>,
        dataIndex: 'buyer',
        key: 'buyer',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('手续费') }</p>,
        dataIndex: 'handlingFee',
        key: 'handlingFee',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('创建时间') }</p>,
        dataIndex: 'createTime',
        key: 'createTime',
        render: text => text
    },
    {
        title: <p style={ titleStyle }>{ t('交易状态') }</p>,
        dataIndex: 'orderStatus',
        key: 'orderStatus',
        render: text => text
    },
    // {
    //   title: <p style={titleStyle}>商品交易链接</p>,
    //   dataIndex: 'orderLink',
    //   key: 'orderLink',
    //   render: text => text
    // },
    {
        title: <p style={ titleStyle }>{ t('操作') }</p>,
        dataIndex: 'operating',
        key: 'operating',
        render: text => text
    }
];


export default OrderContainer;
